/**
 * @generated SignedSource<<147aff81c0bc9285f5ec3fd6ce4f79a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type useWidgetTeamScheduleSubscription$variables = {
  routineIds: ReadonlyArray<string>;
};
export type useWidgetTeamScheduleSubscription$data = {
  readonly routineTaskExecutionChanged: {
    readonly id: string;
    readonly isCompleted: boolean;
    readonly routineOccasion: {
      readonly id: string;
      readonly status: RoutineOccasionStatus;
    };
  } | null;
};
export type useWidgetTeamScheduleSubscription = {
  response: useWidgetTeamScheduleSubscription$data;
  variables: useWidgetTeamScheduleSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "routineIds",
    "variableName": "routineIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineOccasion",
  "kind": "LinkedField",
  "name": "routineOccasion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTeamScheduleSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWidgetTeamScheduleSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "041e662ec74cc8232474b2db7a147b1c",
    "id": null,
    "metadata": {},
    "name": "useWidgetTeamScheduleSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTeamScheduleSubscription(\n  $routineIds: [ID!]!\n) {\n  routineTaskExecutionChanged(routineIds: $routineIds) {\n    __typename\n    id\n    isCompleted\n    routineOccasion {\n      id\n      status(calculateNoTasks: true)\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e68c0409688b758556ea6f400044fcb";

export default node;
